import { baseUrl } from "../../../config";
import { EventBus } from "../../../eventbus";
import { setDocTitle } from "../../../functions/HelperFuncs";
import { thumbnail, errorPlaceholder } from "../../../functions/thumbnail";
import { userHasAllRights } from "../../../functions/userRights.js";
import i18n from "../../../functions/i18next";
import PSD from "psd.js";
import { download } from "../../../functions/download";

export default {
  props: {
    mySpace: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      id: this.$options.name,
      show: false,
      loading: true,
      file: {},
      stats: [
        {
          key: "date",
          label: i18n.t("files.date_added"),
        },
        {
          key: "size",
          label: i18n.t("common.size"),
        },
        {
          key: "dimensions",
          label: i18n.t("files.dimensions"),
        },
      ],
      actionBtns: [
        {
          icon: "download",
          label: i18n.tc("common.download", 1),
          func: this.downloadSelected,
          rights: ["download_files"],
        },
        {
          icon: "transfer",
          label: i18n.t("transfer.transfer"),
          func: this.transferSelected,
          rights: ["transfer_files", "transfer_folders"],
        },
        {
          icon: "collect",
          label: i18n.t("collection.collect"),
          func: this.collectSelected,
          rights: ["collect"],
        },
      ],
      dataThumb: false,
    };
  },
  created() {
    setDocTitle("file", this);

    EventBus.$on("openOverlayPage", (data) => {
      if (this.id === data.id) {
        this.show = true;

        this.file = data;

        this.getExtraFileData(data.file.id);
      } else {
        this.show = false;
      }
    });

    EventBus.$on("closeOverlayPage", (data) => {
      if (this.id === data.id) {
        this.show = false;

        //update url
        this.$router.push(this.$route.path.replace(`/${this.file.id}`, ""));
      }
    });
  },
  methods: {
    setPsdPreview() {
      this.dataThumb = false;

      if (this.file.extension) {
        if (this.file.extension.toLowerCase().replace(".", "") === "psd") {
          PSD.fromURL(this.createDownloadLink()).then((psd) => {
            if (psd.image.toPng().src) {
              this.dataThumb = psd.image.toPng().src;
            }
          });
        }
      }
    },
    checkRights(rights) {
      if (rights) {
        return !userHasAllRights(rights, this);
      }

      return false;
    },
    getExtraFileData(id) {
      this.loading = true;

      this.$axios
        .get(`${baseUrl}/file?file=${id}&myspace=${this.mySpace}`)
        .then((r) => {
          this.file = r.data;

          setDocTitle(this.file.name, this);
          this.loading = false;
        });
    },
    thumb(item, big = false) {
      return thumbnail(item, big);
    },
    onError(e) {
      if (!this.file.thumbnail) {
        errorPlaceholder(e);
      }
    },
    createDownloadLink() {
      let downloadLink = `${baseUrl}/download?file=${this.file.id}`;

      downloadLink += `&company=${this.$store.state.company}`;
      downloadLink += `&myspace=${this.mySpace}`;

      if (this.$store.state.user) {
        downloadLink += `&key=${this.$store.state.user.key}`;
      }

      return downloadLink;
    },

    downloadSelected() {
      // Create a new link
      /*const link = document.createElement("a");
      link.href = this.createDownloadLink();
      link.classList.add("hide");

      // Append to the DOM
      document.body.appendChild(link);

      // Trigger `click` event
      link.click();

      // Remove element from DOM
      document.body.removeChild(link);*/
      download(
        {
          type: "file",
          item: this.file,
        },
        this
      );
    },

    collectSelected() {
      EventBus.$emit("openOverlayPage", {
        id: "collect-file",
        selectedFiles: [this.file],
      });
    },
    transferSelected() {
      //set transfering mode
      this.$store.state.isTransfering = true;

      //get selected files for transfer
      this.$store.state.transferItems = {
        selectedFiles: [this.file],
        selectedFolders: [],
        collection: [],
      };

      //got to the url
      this.$router.push(`/${this.$store.state.company}/mobile-transfer/ready`);
    },
  },
  computed: {
    canEditFiles() {
      return !userHasAllRights(["delete_files", "rename_files"], this);
    },
  },
  watch: {
    show() {
      EventBus.$emit("top-options-show", {
        show: false,
      });
    },
  },
};
